module.exports = __webpack_public_path__ + "static/media/popupimg.66505bda.jpg";